module.exports = "<div class=\"modal-header\"> <h3 class=\"modal-title\" style=\"float:left\">{{ vm.title }}</h3> <button type=\"button\" class=\"close\" ng-click=\"vm.no()\">&times;</button> </div> <div class=\"modal-body\"> {{ vm.text }} </div> <div class=\"modal-footer\"> <button class=\"btn btn-serf\" ng-click=\"vm.no()\" data-translate=\"LABEL_NEIN\"></button> <button class=\"btn btn-serf\" ng-click=\"vm.yes()\" data-translate=\"LABEL_JA\"></button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/dialog/yesNoTemplate.html
// module id = 8KBA
// module chunks = 0